import { render, staticRenderFns } from "./SupplierOrderReject.vue?vue&type=template&id=0beb73d2&"
import script from "./SupplierOrderReject.vue?vue&type=script&lang=js&"
export * from "./SupplierOrderReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports